const baseUrl = process.env.VUE_APP_API_URL_SPORTS_SG;

export default {
    async login(credentials) {
        let response = await fetch(baseUrl + '/active-health/login',
        {
            method: "POST",
            body: JSON.stringify(credentials),
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if(response.status == 200){
            return await response.json();
        }
        else{
            return Promise.reject(response);
        } 
    },
    async getLeaderBoard(data) {
        let response = await fetch(baseUrl + '/active-health/upload-user-details-and-get-leaderboard',
        {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('login')).accessToken
            }
        })
        if(response.status == 200){
            return await response.json();
        }
        else{
            return Promise.reject(response);
        } 
    },
    async getAgeLimit() {
        const headers = {
            'authorization': 'Bearer ' + JSON.parse(localStorage.getItem('login')).accessToken
        }
        let response = await fetch(baseUrl + '/active-health/age-limit',
            { headers: headers }
        );
        if(response.status == 200){
            return await response.json();
        }
        else{
            return Promise.reject(response);
        } 
    },
    async refreshToken() {
        let response = await fetch(baseUrl + '/active-health/web-refresh-token',
        {
            method: "POST",
            body: localStorage.getItem('login') ?? null,
            headers: {
                'Content-Type': 'application/json',
            }
        })
        if(response.status == 200){
            return await response.json();
        }
        else{
            return Promise.reject(response);
        } 
    },
    async getLeaderBoardV2(){
         let response = await fetch(
           baseUrl + "/active-health/get-leaderboard",
           {
             method: "GET",
             headers: {
               "Content-Type": "application/json",
               Authorization:
                 "Bearer " +
                 JSON.parse(localStorage.getItem("login")).accessToken,
             },
           }
         );
         if (response.status == 200) {
           return await response.json();
         } else {
           return Promise.reject(response);
         } 
    }
}
